<template>
  <v-container fluid>
    <v-layout>
      <v-flex md12>
        <table class="tableOverall">
          <tr>
            <th class="tableItemsTH">#</th>
            <th class="tableItemsTH"></th>
            <th class="tableItemsTH">
              <v-tooltip top>
                <span slot="activator">MC</span>
                <span>Merchant Code</span>
              </v-tooltip>
            </th>
            <th class="tableItemsTH">Device Serial</th>
            <th class="tableItemsTH">Branch</th>
            <th
              class="tableItemsTH"
              style="border-right: 2px solid black;  cursor: pointer;"
              @click="toggleDate"
            >
              Opening Shift Date
              <v-icon style="font-size: 10px;">{{
                toggStatus ? "arrow_downward" : "arrow_upward"
              }}</v-icon>
            </th>
            <th class="tableItemsTH" style="border-left: 2px solid black;">
              Closing Shift Date
            </th>
            <th class="tableItemsTH" style="border-left: 2px solid black;">
              Date Validation
            </th>
            <th
              class="tableItemsTH text-no-wrap"
              style="border-left: 2px solid black;"
            >
              Reload Count (W)
            </th>
            <th class="tableItemsTH text-no-wrap">
              Reload Gross (W)
            </th>
            <th class="tableItemsTH text-no-wrap">
              Sold Count (W)
            </th>
            <th class="tableItemsTH text-no-wrap">
              Sold Gross (W)
            </th>
            <th class="tableItemsTH text-no-wrap">
              Sold Credit Count (W)
            </th>
            <th class="tableItemsTH text-no-wrap">
              Sold Credit Gross (W)
            </th>
            <th class="tableItemsTH" style="border-right: 2px solid black;">
              Credit Redeem Count (W)
            </th>
            <th class="tableItemsTH text-no-wrap">
              Credit Count (W)
            </th>
            <th class="tableItemsTH text-no-wrap">
              Credit Gross (W)
            </th>
            <th class="tableItemsTH text-no-wrap">
              Transfer Count (W)
            </th>
            <th class="tableItemsTH text-no-wrap">
              Transfer Fee Card (W)
            </th>
            <th class="tableItemsTH text-no-wrap">
              Transfer Fee Cash (W)
            </th>
            <th class="tableItemsTH text-no-wrap">
              Transfer Fee Gross (W)
            </th>
            <th class="tableItemsTH text-no-wrap">
              Amount (W)
            </th>
            <th class="tableItemsTH" style="border-right: 2px solid black;">
              Total Count (W)
            </th>
            <th
              class="tableItemsTH text-no-wrap"
              style="border-left: 2px solid black;"
            >
              Reload Count (S)
            </th>
            <th class="tableItemsTH text-no-wrap">
              Reload Gross (S)
            </th>
            <th class="tableItemsTH text-no-wrap">
              Sold Count (S)
            </th>
            <th class="tableItemsTH text-no-wrap">
              Sold Gross (S)
            </th>
            <th class="tableItemsTH text-no-wrap">
              Sold Credit Count (S)
            </th>
            <th class="tableItemsTH text-no-wrap">
              Sold Credit Gross (S)
            </th>
            <th class="tableItemsTH" style="border-right: 2px solid black;">
              Credit Redeem Count (S)
            </th>
            <th class="tableItemsTH text-no-wrap">
              Credit Count (S)
            </th>
            <th class="tableItemsTH text-no-wrap">
              Credit Gross (S)
            </th>
            <th class="tableItemsTH text-no-wrap">
              Transfer Count (S)
            </th>
            <th class="tableItemsTH text-no-wrap">
              Transfer Fee Gross (S)
            </th>
            <th class="tableItemsTH text-no-wrap">
              Transfer Fee Card (S)
            </th>
            <th class="tableItemsTH text-no-wrap">
              Transfer Fee Cash (S)
            </th>
            <th class="tableItemsTH text-no-wrap">
              Amount (S)
            </th>
            <th class="tableItemsTH" style="border-right: 2px solid black;">
              Total Count (s)
            </th>
            <th class="tableItemsTH" style="border-left: 2px solid black;">
              Validation
            </th>
            <th class="tableItemsTH" style="border-left: 2px solid black;">
              Cashier Name
            </th>
          </tr>
          <tr class="tableTR" v-for="(item, index) in items" :key="item.key">
            <td
              :class="[
                'text-xs-center',
                item.shift_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              {{ index + 1 }}
            </td>
            <td
              :class="[
                'text-xs-center',
                item.shift_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              <v-tooltip top>
                <a
                  class="teal--text"
                  slot="activator"
                  v-if="
                    $moduleAccess('align_shift_report') &&
                      item.shift_status !== 0 &&
                      item.shift_status !== 3
                  "
                  @click="syncToWireless(item)"
                  >align</a
                >
                <span>Align</span>
              </v-tooltip>
            </td>

            <td
              :class="[
                'text-xs-center text-uppercase',
                item.shift_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              {{ item.merchant }}
            </td>
            <td
              :class="[
                'text-xs-center',
                item.shift_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              {{ item.device_serial }}
            </td>
            <td
              :class="[
                'text-xs-center text-uppercase text-no-wrap',
                item.shift_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              {{ item.terminal }}
            </td>
            <td
              :class="[
                'text-xs-center text-uppercase text-no-wrap',
                item.shift_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
              style="border-right: 2px solid black;"
            >
              {{
                item.opening_shift_datetime === null
                  ? "--"
                  : $dateFormat(item.opening_shift_datetime, "YYYY-MM-DD")
              }}
            </td>
            <td
              :class="[
                'text-xs-center text-uppercase text-no-wrap',
                item.shift_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
              style="border-right: 2px solid black;"
            >
              {{
                item.closing_shift_datetime === null
                  ? "--"
                  : $dateFormat(item.closing_shift_datetime, "YYYY-MM-DD")
              }}
            </td>
            <td
              :class="[
                'text-xs-center text-uppercase text-no-wrap',
                item.shift_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
              style="border-right: 2px solid black;"
            >
              {{ item.date_validation === null ? "--" : item.date_validation }}
            </td>
            <td
              :class="[
                'text-xs-right text-uppercase',
                item.shift_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
              style="border-left: 2px solid black;"
            >
              {{
                item.reload_count_wireless == null
                  ? "N/A"
                  : item.reload_count_wireless
              }}
            </td>
            <td
              :class="[
                'text-xs-right',
                item.shift_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              {{
                item.reload_gross_wireless == null
                  ? "N/A"
                  : $amountInPeso(item.reload_gross_wireless)
              }}
            </td>
            <td
              :class="[
                'text-xs-right text-uppercase',
                item.shift_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              {{
                item.sold_count_wireless == null
                  ? "N/A"
                  : item.sold_count_wireless
              }}
            </td>
            <td
              :class="[
                'text-xs-right text-uppercase',
                item.shift_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              {{
                item.sold_gross_wireless == null
                  ? "N/A"
                  : $amountInPeso(item.sold_gross_wireless)
              }}
            </td>
            <td
              :class="[
                'text-xs-right text-uppercase',
                item.shift_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              {{
                item.credit_sold_count_wireless == null
                  ? "N/A"
                  : item.credit_sold_count_wireless
              }}
            </td>
            <td
              :class="[
                'text-xs-right text-uppercase',
                item.shift_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              {{
                item.credit_sold_gross_wireless == null
                  ? "N/A"
                  : $amountInPeso(item.credit_sold_gross_wireless)
              }}
            </td>
            <td
              :class="[
                'text-xs-right text-uppercase',
                item.shift_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              {{
                item.credit_redeem_count_wireless == null
                  ? "N/A"
                  : $amountInPeso(item.credit_redeem_count_wireless)
              }}
            </td>
            <td
              :class="[
                'text-xs-right text-uppercase',
                item.shift_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              {{
                item.credit_count_wireless == null
                  ? "N/A"
                  : item.credit_count_wireless
              }}
            </td>
            <td
              :class="[
                'text-xs-right text-uppercase',
                item.shift_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              {{
                item.credit_gross_wireless == null
                  ? "N/A"
                  : $amountInPeso(item.credit_gross_wireless)
              }}
            </td>
            <td
              :class="[
                'text-xs-right text-uppercase',
                item.shift_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              {{
                item.transfer_count_wireless == null
                  ? "--"
                  : item.transfer_count_wireless
              }}
            </td>

            <td
              :class="[
                'text-xs-right text-uppercase',
                item.shift_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              {{
                item.transfer_fee_gross_wireless == null
                  ? "--"
                  : item.transfer_fee_gross_wireless
              }}
            </td>
            <td
              :class="[
                'text-xs-right text-uppercase',
                item.shift_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              {{
                item.transfer_fee_gross_wireless == null
                  ? "--"
                  : item.transfer_fee_gross_wireless
              }}
            </td>
            <td
              :class="[
                'text-xs-right text-uppercase',
                item.shift_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              {{
                item.transfer_fee_gross_wireless == null
                  ? "--"
                  : item.transfer_fee_gross_wireless
              }}
            </td>
            <td
              :class="[
                'text-xs-right text-uppercase',
                item.shift_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
              style="border-right: 2px solid black;"
            >
              {{
                item.gross_revenue_wireless == null
                  ? "N/A"
                  : $amountInPeso(item.gross_revenue_wireless)
              }}
            </td>
            <td
              :class="[
                'text-xs-right text-uppercase',
                item.shift_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
              style="border-right: 2px solid black;"
            >
              {{
                item.reload_count_wireless +
                  item.sold_count_wireless +
                  item.credit_sold_count_wireless +
                  item.credit_redeem_count_wireless +
                  item.credit_count_wireless +
                  item.transfer_count_wireless
              }}
            </td>
            <td
              :class="[
                'text-xs-right text-uppercase',
                item.shift_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
              style="border-left: 2px solid black;"
            >
              {{
                item.reload_count_sync == null ? "N/A" : item.reload_count_sync
              }}
            </td>
            <td
              :class="[
                'text-xs-right',
                item.shift_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              {{
                item.reload_gross_sync == null
                  ? "N/A"
                  : $amountInPeso(item.reload_gross_sync)
              }}
            </td>
            <td
              :class="[
                'text-xs-right text-uppercase',
                item.shift_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              {{ item.sold_count_sync == null ? "N/A" : item.sold_count_sync }}
            </td>
            <td
              :class="[
                'text-xs-right text-uppercase',
                item.shift_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              {{
                item.sold_gross_sync == null
                  ? "N/A"
                  : $amountInPeso(item.sold_gross_sync)
              }}
            </td>
            <td
              :class="[
                'text-xs-right text-uppercase',
                item.shift_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              {{
                item.credit_sold_count_sync == null
                  ? "N/A"
                  : item.credit_sold_count_sync
              }}
            </td>
            <td
              :class="[
                'text-xs-right text-uppercase',
                item.shift_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              {{
                item.credit_sold_gross_sync == null
                  ? "N/A"
                  : $amountInPeso(item.credit_sold_gross_sync)
              }}
            </td>
            <td
              :class="[
                'text-xs-right text-uppercase',
                item.shift_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              {{
                item.credit_redeem_count_sync == null
                  ? "N/A"
                  : $amountInPeso(item.credit_redeem_count_sync)
              }}
            </td>
            <td
              :class="[
                'text-xs-right text-uppercase',
                item.shift_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              {{
                item.credit_count_sync == null
                  ? "N/A"
                  : $amountInPeso(item.credit_count_sync)
              }}
            </td>
            <td
              :class="[
                'text-xs-right text-uppercase',
                item.shift_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              {{
                item.credit_gross_sync == null
                  ? "N/A"
                  : $amountInPeso(item.credit_gross_sync)
              }}
            </td>
            <td
              :class="[
                'text-xs-right text-uppercase',
                item.shift_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              {{
                item.transfer_count_sync == null
                  ? "--"
                  : item.transfer_count_sync
              }}
            </td>
            <td
              :class="[
                'text-xs-right text-uppercase',
                item.shift_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              {{
                item.transfer_fee_card_sync == null
                  ? "--"
                  : item.transfer_fee_card_sync
              }}
            </td>

            <td
              :class="[
                'text-xs-right text-uppercase',
                item.shift_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              {{
                item.transfer_fee_cash_sync == null
                  ? "--"
                  : item.transfer_fee_cash_sync
              }}
            </td>

            <td
              :class="[
                'text-xs-right text-uppercase',
                item.shift_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
            >
              {{
                item.transfer_fee_gross_sync == null
                  ? "--"
                  : item.transfer_fee_gross_sync
              }}
            </td>
            <td
              :class="[
                'text-xs-right text-uppercase',
                item.shift_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
              style="border-right: 2px solid black;"
            >
              {{
                item.gross_revenue_sync == null
                  ? "N/A"
                  : $amountInPeso(item.gross_revenue_sync)
              }}
            </td>
            <td
              :class="[
                'text-xs-right text-uppercase',
                item.shift_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
              style="border-right: 2px solid black;"
            >
              {{
                item.reload_count_sync +
                  item.sold_count_sync +
                  item.credit_sold_count_sync +
                  item.credit_redeem_count_sync +
                  item.credit_count_sync +
                  item.transfer_count_sync
              }}
            </td>
            <td
              :class="[
                'text-xs-right',
                item.shift_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
              style="border-left: 2px solid black;"
            >
              {{
                item.discrepancy == null
                  ? "N/A"
                  : $amountInPeso(item.discrepancy)
              }}
            </td>
            <td
              :class="[
                'text-xs-left no-wrap',
                item.shift_status != 0 ? 'tableItemsTD2' : 'tableItemsTD',
              ]"
              style="border-left: 2px solid black;"
            >
              {{ item.cashier_name == null ? "N/A" : item.cashier_name }}
            </td>
          </tr>
        </table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
var now = new Date();

export default {
  props: {
    items: Array,
    toggStatus: Boolean,
  },
  data() {
    return {
      queryParams: {
        search: "",
        transaction_id: null,
        type: null,
      },
      dateFrom: this.$dateFormat(now, "YYYY-MM-DD"),
      dateTo: this.$dateFormat(now, "YYYY-MM-DD"),
    };
  },
  methods: {
    toggleDate() {
      this.$emit("toggleDate");
    },
    syncToWireless(data) {
      this.$emit("sync", data);
    },
  },
};
</script>

<style scoped>
.tableOverall {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
  height: 95%;
  border: 3px solid #000000;
}

.tableItemsTH {
  border: 1px solid #000000;
  padding: 4px;
  font-size: 10px;
  font-weight: bold;
}

.tableItemsTD {
  border: 1px solid #000000;
  /* text-align: right; */
  padding: 2px;
  font-size: 9px;
  font-weight: bold;
}

.tableItemsTD2 {
  border: 1px solid #000000;
  /* text-align: right; */
  color: red;
  padding: 2px;
  font-size: 9px;
  font-weight: bolder;
}

.tableTR:hover {
  background-color: #ddd;
}
</style>
